export default __webpack_public_path__ + "static/media/ic_designation_48px.0f33e9ab.svg";